import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserClientContactUpdatePage = lazy(() => import('../views/update/UserClientContactUpdatePage'));

export function UserClientContactUpdatePageLazy() {
	return (
		<PageSuspense>
			<UserClientContactUpdatePage />
		</PageSuspense>
	);
}
